import { useState, useEffect } from "react";
import { onMobile } from "../../utils/environment";

// Define general type for useWindowSize hook, which includes width and height
export interface WindowSize {
  width: number;
  height: number;
  mobile: boolean;
  mobileView: boolean;
}

export function getCurrentWindow(): WindowSize {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    mobile: onMobile(),
    mobileView: onMobile() || window.innerWidth < 1200,
  };
}

function useWindowSize(): WindowSize {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
    mobile: false,
    mobileView: false,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize(getCurrentWindow());
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

export default useWindowSize;